import { render, staticRenderFns } from "./SmtpIssueBody.vue?vue&type=template&id=3796eb50&scoped=true"
import script from "./SmtpIssueBody.vue?vue&type=script&lang=js"
export * from "./SmtpIssueBody.vue?vue&type=script&lang=js"
import style0 from "./SmtpIssueBody.vue?vue&type=style&index=0&id=3796eb50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3796eb50",
  null
  
)

export default component.exports